import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import CurrentStocks from "./CurrentStocks";
import CompletedLists from "./CompletedLists";
import Wallet from "./Wallet";
import { BsChevronDoubleUp, BsChevronDoubleDown } from "react-icons/bs";
import Search from "./Search";
import NavBar from "./NavBar";
import Footer from "./Footer";
import Alert from "./Alert";
import AlertSold from "./AlertSold";
import EditStock from "./EditStock";
import AddStock from "./AddStock";
import $ from "jquery";
import Ads from "./Ads.png";

export default function BuyingLists() {
  const [buyingList, setBuyingLists] = useState([
    {
      id: "1616192982352",
      date: "2021-03-14",
      company: "6020 - جاكو",
      quantity: "500",
      price: "28.20",
      totalFees: 24.455745,
      completed: false,
      total: 14124.455745,
      sold: [],
    },
    {
      id: "1616193604892",
      date: "2021-03-11",
      company: "1150 - الإنماء",
      quantity: "2000",
      price: "17.04",
      totalFees: 59.110056,
      completed: false,
      total: 34139.110056,
      sold: [
        {
          id: "1639603341581",
          date: "2021-03-18",
          quantity: "1000",
          soldPrice: "18.16",
          totalFees: 31.49852,
          profit: 1058.9456,
          percentage: 6.203709150047318,
          total: 18128.50148,
          totalCost: 17069.55588,
        },
      ],
    },
    {
      id: "1616192116437",
      date: "2021-02-28",
      company: "1810 - سيرا القابضة",
      quantity: "1236",
      price: "17.18",
      totalFees: 36.830143836,
      completed: false,
      total: 21271.310143836003,
      sold: [
        {
          id: "1639603418037",
          date: "2021-03-16",
          quantity: "500",
          soldPrice: "19.1",
          totalFees: 16.564475,
          profit: 928.5361700000001,
          percentage: 10.790784780770979,
          total: 9533.435525,
          totalCost: 8604.899355,
        },
      ],
    },
    {
      id: "1616266356250",
      date: "2021-01-11",
      company: "4031 - الخدمات الأرضية",
      quantity: "1500",
      price: "32.50",
      totalFees: 84.5544375,
      completed: false,
      total: 48834.5544375,
      sold: [],
    },
    {
      id: "1616119058435",
      date: "2020-12-07",
      company: "2110 - الكابلات",
      quantity: "500",
      price: "31",
      totalFees: 26.883975,
      completed: true,
      total: 15526.883974999999,
      sold: [
        {
          id: "1616119352789",
          date: "2020-12-21",
          quantity: "500",
          soldPrice: "29.2",
          totalFees: 25.322969999999998,
          profit: -952.2069449999999,
          percentage: -5.806451612903226,
          total: 14574.67703,
        },
      ],
      peroid: 14,
      allFees: 52.206945,
      avgPrice: 29.2,
      totalProfits: -952.2069449999999,
      totalCosts: 15552.206944999998,
      percentage: -6.122648369890245,
      net: 14574.677029999999,
    },
    {
      id: "1616103019242",
      date: "2020-12-03",
      company: "2180 - فيبكو",
      quantity: "500",
      price: "60.5",
      totalFees: 52.4671125,
      completed: true,
      total: 30302.467112500002,
      sold: [
        {
          id: "1616103379247",
          date: "2020-12-07",
          quantity: "500",
          soldPrice: "58.6",
          totalFees: 50.819385,
          profit: -1053.2864975000002,
          percentage: -3.1404958677685952,
          total: 29249.180614999997,
        },
      ],
      peroid: 4,
      allFees: 103.2864975,
      avgPrice: 58.6,
      totalProfits: -1053.2864975000002,
      totalCosts: 30353.2864975,
      percentage: -3.4700904549059373,
      net: 29249.180615,
    },
    {
      id: "1616012380896",
      date: "2020-11-29",
      company: "2030 - المصافي",
      quantity: "250",
      price: "90.40",
      totalFees: 39.198570000000004,
      completed: true,
      total: 22639.19857,
      sold: [
        {
          id: "1616012453721",
          date: "2020-12-17",
          quantity: "250",
          soldPrice: "115",
          totalFees: 49.8654375,
          profit: 6060.935992500001,
          percentage: 27.212389380530972,
          total: 28700.1345625,
        },
      ],
      peroid: 18,
      allFees: 89.0640075,
      avgPrice: 115,
      totalProfits: 6060.935992500001,
      totalCosts: 22689.0640075,
      percentage: 26.713027873236744,
      net: 28700.134562500003,
    },
    {
      id: "1616012185373",
      date: "2020-11-04",
      company: "4011 - لازوردي",
      quantity: "500",
      price: "16.76",
      totalFees: 14.534690999999999,
      completed: true,
      total: 8394.534690999999,
      sold: [
        {
          id: "1616012248611",
          date: "2020-11-25",
          quantity: "500",
          soldPrice: "21.60",
          totalFees: 18.732059999999997,
          profit: 2386.7332490000003,
          percentage: 28.878281622911693,
          total: 10781.26794,
        },
      ],
      peroid: 21,
      allFees: 33.266751,
      avgPrice: 21.6,
      totalProfits: 2386.7332490000003,
      totalCosts: 8413.266751,
      percentage: 28.368686262281102,
      net: 10781.26794,
    },
    {
      id: "1616120628670",
      date: "2020-10-14",
      company: "4050 - خدمات السيارت",
      quantity: "1000",
      price: "33.2",
      totalFees: 57.58374,
      completed: true,
      total: 33257.58374,
      sold: [
        {
          id: "1616120781355",
          date: "2020-10-28",
          quantity: "1000",
          soldPrice: "30.10",
          totalFees: 52.206945000000005,
          profit: -3209.7906850000004,
          percentage: -9.33734939759036,
          total: 30047.793055000002,
        },
      ],
      peroid: 14,
      allFees: 109.790685,
      avgPrice: 30.1,
      totalProfits: -3209.7906850000004,
      totalCosts: 33309.790685,
      percentage: -9.636177889419843,
      net: 30047.793055000002,
    },
    {
      id: "1616011814945",
      date: "2020-07-23",
      company: "4190 - جرير",
      quantity: "100",
      price: "150.00",
      totalFees: 26.016750000000002,
      completed: true,
      total: 15026.01675,
      sold: [
        {
          id: "1616011974237",
          date: "2020-08-13",
          quantity: "100",
          soldPrice: "169",
          totalFees: 29.312205,
          profit: 1844.671045,
          percentage: 12.666666666666668,
          total: 16870.687795,
        },
      ],
      peroid: 21,
      allFees: 55.328955,
      avgPrice: 169,
      totalProfits: 1844.671045,
      totalCosts: 15055.328955,
      percentage: 12.252612018732206,
      net: 16870.687795,
    },
    {
      id: "1616265793994",
      date: "2020-05-05",
      company: "4291 - الوطنية للتربية والتعليم",
      quantity: "826",
      price: "33.7",
      totalFees: 48.28049709,
      completed: true,
      total: 27884.48049709,
      sold: [
        {
          id: "1616266040162",
          date: "2020-05-31",
          quantity: "826",
          soldPrice: "36.5",
          totalFees: 52.29193305,
          profit: 2212.227569859999,
          percentage: 8.308605341246288,
          total: 30096.70806695,
        },
      ],
      peroid: 26,
      allFees: 100.57243014,
      avgPrice: 36.5,
      totalProfits: 2212.227569859999,
      totalCosts: 27936.77243014,
      percentage: 7.918694170530969,
      net: 30096.70806695,
    },
    {
      id: "1616104344855",
      date: "2020-05-05",
      company: "2300 - صناعة الورق",
      quantity: "2000",
      price: "11.10",
      totalFees: 38.50479,
      completed: true,
      total: 22238.50479,
      sold: [
        {
          id: "1616104529315",
          date: "2020-11-09",
          quantity: "2000",
          soldPrice: "35.20",
          totalFees: 122.10528,
          profit: 48039.38992999999,
          percentage: 217.11711711711712,
          total: 70277.89472000001,
        },
      ],
      peroid: 188,
      allFees: 160.61007,
      avgPrice: 35.2,
      totalProfits: 48039.38992999999,
      totalCosts: 22360.61007,
      percentage: 214.83935268140021,
      net: 70277.89471999998,
    },
    {
      id: "1616263534193",
      date: "2020-04-06",
      company: "7010 - اس تي سي",
      quantity: "368",
      price: "89.50",
      totalFees: 57.12584519999999,
      completed: true,
      total: 32993.1258452,
      sold: [
        {
          id: "1616263683390",
          date: "2020-05-03",
          quantity: "368",
          soldPrice: "86.80",
          totalFees: 55.40249567999999,
          profit: -1106.128340880002,
          percentage: -3.016759776536319,
          total: 31886.99750432,
        },
      ],
      peroid: 27,
      allFees: 112.52834087999997,
      avgPrice: 86.8,
      totalProfits: -1106.128340880002,
      totalCosts: 33048.528340879995,
      percentage: -3.3469821393279893,
      net: 31886.997504319996,
    },
    {
      id: "1616263852044",
      date: "2020-03-17",
      company: "8012 - جزيرة تكافل",
      quantity: "2000",
      price: "12.6",
      totalFees: 43.70813999999999,
      completed: true,
      total: 25243.708140000002,
      sold: [
        {
          id: "1616263937815",
          date: "2020-03-26",
          quantity: "2000",
          soldPrice: "14.68",
          totalFees: 50.923452,
          profit: 4065.3684079999994,
          percentage: 16.507936507936506,
          total: 29309.076547999997,
        },
      ],
      peroid: 9,
      allFees: 94.63159199999998,
      avgPrice: 14.68,
      totalProfits: 4065.3684079999994,
      totalCosts: 25294.631592,
      percentage: 16.07206016507378,
      net: 29309.076548,
    },
    {
      id: "1616119760607",
      date: "2020-02-27",
      company: "1831 - مهارة",
      quantity: "500",
      price: "73.6",
      totalFees: 63.82776,
      completed: true,
      total: 36863.82776,
      sold: [
        {
          id: "1616119904788",
          date: "2020-03-10",
          quantity: "500",
          soldPrice: "56.2",
          totalFees: 48.738045,
          profit: -8812.565805,
          percentage: -23.641304347826086,
          total: 28051.261954999998,
        },
      ],
      peroid: 12,
      allFees: 112.565805,
      avgPrice: 56.2,
      totalProfits: -8812.565805,
      totalCosts: 36912.565805,
      percentage: -23.874162125587848,
      net: 28051.261955,
    },
    {
      id: "1616102202961",
      date: "2020-01-08",
      company: "2380 - بترو رابغ",
      quantity: "1000",
      price: "20",
      totalFees: 34.689,
      completed: true,
      total: 20034.689,
      sold: [
        {
          id: "1616102268530",
          date: "2020-02-12",
          quantity: "1000",
          soldPrice: "17.2",
          totalFees: 29.83254,
          profit: -2864.5215399999997,
          percentage: -14.000000000000002,
          total: 17170.16746,
        },
      ],
      peroid: 35,
      allFees: 64.52154,
      avgPrice: 17.2,
      totalProfits: -2864.5215399999997,
      totalCosts: 20064.521539999998,
      percentage: -14.276550448957279,
      net: 17170.167459999997,
    },
  ]);
  const [show, setShow] = useState(true);
  const [wallet, setWallet] = useState(100000);
  const [fees, setFees] = useState(0.155);
  const [vat, setVat] = useState(15);
  const [currentStocks, setCurrentStocks] = useState(0);
  const [balance, setBalance] = useState(0);
  const [total, setTotal] = useState(0);
  const [profits, setProfit] = useState(0);
  const [loses, setLoses] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const stockID = useRef();
  //لمعرفة تاريخ الشراء ومقارنته مع حقل تاريخ البيع لكي لايكون التاريخ سابق لتاريخ الشراء
  const Bdate = useRef();
  const editStockId = useRef();
  const addStockId = useRef();
  const buyDate = useRef();
  const buyDateEdit = useRef();
  const buyPrice = useRef();
  const buyPriceEdit = useRef();
  const buyPriceAdd = useRef();
  const buyQuantity = useRef();
  const buyQuantityEdit = useRef();
  const buyQuantityAdd = useRef();
  const buyNewQnty = useRef();
  const buyNewPrice = useRef();
  const buyNewTotal = useRef();
  const buyNewQntyPrice = useRef();
  const buyNewQntyPriceVat = useRef();
  const buyNewFinalTotal = useRef();
  const buyNumber = useRef();
  const buyNumberEdit = useRef();
  const buyNumberAdd = useRef();
  const selectedStock = useRef();
  const currentStock = useRef();
  const soldDate = useRef();
  const soldQuantity = useRef();
  const soldRemainQty = useRef();
  const soldPrice = useRef();

  useEffect(() => {
    handleWallet();
    $('[data-toggle="tooltip"]').tooltip();
  }, [buyingList]);

  useEffect(() => {
    $("#AdsModal").modal("show");
  }, []);

  const handleAddStock = (e) => {
    e.preventDefault();
    const date = buyDate.current.value;
    const company = buyNumber.current.value;
    const quantity = buyQuantity.current.value;
    const price = buyPrice.current.value;
    let newFee = fees / 100;
    let newVat = vat / 100;
    if (!date || !company || !quantity || !price) {
      formBuyingValidation();
      return;
    }
    setBuyingLists((prevList) => {
      return [
        {
          id: new Date().getTime().toString(),
          date: date,
          company: company,
          quantity: quantity,
          price: price,
          totalFees:
            quantity * price * newFee + quantity * price * 0.00123 * newVat,
          completed: false,
          total:
            quantity * price +
            quantity * price * newFee +
            quantity * price * 0.00123 * newVat,
          sold: [],
        },
        ...prevList,
      ];
    });
    removeValidation();
    if (document.getElementById("buyingModalSuccess")) {
      document.getElementById("buyingModalSuccess").classList.remove("d-none");
    }
  };
  const handleEditedStock = (id, validation) => {
    const stockId = id;
    const date = buyDateEdit.current.value;
    const company = document.querySelectorAll("#dropdownMenu")[0].value;
    const quantity = buyQuantityEdit.current.value;
    const price = buyPriceEdit.current.value;
    let newFee = fees / 100;
    let newVat = vat / 100;
    if (!date || !company || !quantity || !price) {
      validation();
      return;
    }
    const stock = buyingList.find((list) => list.id === stockId);
    const prevList = buyingList.filter((list) => list.id !== stockId);
    stock.date = date;
    stock.company = company;
    stock.quantity = quantity;
    stock.price = price;
    stock.totalFees =
      stock.quantity * stock.price * newFee +
      stock.quantity * stock.price * 0.00123 * newVat;
    stock.total =
      stock.quantity * stock.price +
      stock.quantity * stock.price * newFee +
      stock.quantity * stock.price * 0.00123 * newVat;
    setBuyingLists([stock, ...prevList]);
    getEditedStock(stock.id);
    setSearchInput(company);
    if (document.getElementById("editingModalSuccess")) {
      document.getElementById("editingModalSuccess").classList.remove("d-none");
    }
  };

  const handleSoldStock = () => {
    const stockId = stockID.current.value;
    const date = soldDate.current.value;
    const quantity = soldRemainQty.current.value;
    const price = soldPrice.current.value;
    let newFee = fees / 100;
    let newVat = vat / 100;
    const addSoldStock = buyingList.find((list) => list.id === stockId);
    if (!date || !quantity || !price) {
      formSellingValidation();
      return;
    }
    const completedList = [];
    const totalFees = [];
    const soldPrices = [];
    const totalProfits = [];
    const dateArr = [];
    addSoldStock.sold = [
      {
        id: new Date().getTime().toString(),
        date,
        quantity,
        soldPrice: price,
        totalFees:
          quantity * price * newFee + quantity * price * 0.00123 * newVat,
        profit:
          quantity * price -
          quantity * addSoldStock.price -
          quantity * addSoldStock.price * newFee -
          quantity * addSoldStock.price * 0.00123 * newVat -
          quantity * price * newFee -
          quantity * price * 0.00123 * newVat,
        percentage:
          ((quantity * price -
            quantity * addSoldStock.price -
            quantity * addSoldStock.price * newFee -
            quantity * addSoldStock.price * 0.00123 * newVat -
            quantity * price * newFee -
            quantity * price * 0.00123 * newVat) /
            (quantity * addSoldStock.price +
              quantity * addSoldStock.price * newFee +
              quantity * addSoldStock.price * 0.00123 * newVat)) *
          100,
        total:
          quantity * price -
          quantity * price * newFee -
          quantity * price * 0.00123 * newVat,
        totalCost:
          quantity * addSoldStock.price +
          quantity * addSoldStock.price * newFee +
          quantity * addSoldStock.price * 0.00123 * newVat,
      },
      ...addSoldStock.sold,
    ];
    addSoldStock.sold.forEach((list) => {
      completedList.push(+list.quantity);
      totalFees.push(+list.totalFees);
      soldPrices.push(+list.soldPrice);
      totalProfits.push(+list.profit);
      dateArr.push(list.date);
    });
    const stocksQty = completedList.reduce((a, b) => a + b);
    const finalFees = totalFees.reduce((a, b) => a + b);
    const avgPrice = soldPrices.reduce((a, b) => a + b) / soldPrices.length;
    const profits = totalProfits.reduce((a, b) => a + b);
    if (stocksQty >= addSoldStock.quantity) {
      //الحصول على تواريخ الشراء والبيع وحساب الفترة بينهم
      let lastDate = dateArr.sort().slice(-1);
      lastDate = new Date(lastDate[0]);
      const firstDate = new Date(addSoldStock.date);
      const diff = lastDate.getTime() - firstDate.getTime();
      const days = Math.ceil(diff / (1000 * 3600 * 24));
      addSoldStock.peroid = days;
      addSoldStock.completed = true;
      addSoldStock.allFees = finalFees + addSoldStock.totalFees;
      addSoldStock.avgPrice = avgPrice;
      addSoldStock.totalProfits = profits;
      addSoldStock.totalCosts = finalFees + addSoldStock.total;
      addSoldStock.percentage =
        (profits / (finalFees + addSoldStock.total)) * 100;
      addSoldStock.net = addSoldStock.total + profits;
    }
    const newList = buyingList.filter((list) => list.id !== stockId);
    setBuyingLists([addSoldStock, ...newList]);
    soldDate.current.value = "";
    soldRemainQty.current.value = "";
    soldPrice.current.value = "";
    if (document.getElementById("sellingModalSuccess")) {
      document.getElementById("sellingModalSuccess").classList.remove("d-none");
    }
    handleGetStock(stockId);
  };

  const deleteStock = (stockId) => {
    const prevList = buyingList.filter((list) => list.id !== stockId);
    setBuyingLists(prevList);
  };

  const deleteSoldStock = (mainStock, subStock) => {
    const removeSubStock = buyingList.find((list) => list.id === mainStock);
    const removed = removeSubStock.sold.filter((list) => list.id !== subStock);
    removeSubStock.sold = removed;
    const newList = buyingList.filter((list) => list.id !== mainStock);
    setBuyingLists([removeSubStock, ...newList]);
  };

  const handleGetStock = (id) => {
    const stockId = id;
    let qntyArr = [];
    let stock = buyingList.find((list) => list.id === stockId);
    stock.sold.forEach((stock) => qntyArr.push(+stock.quantity));
    const soldQty = qntyArr.reduce((a, b) => a + b, 0);
    stockID.current.value = stock.id;
    Bdate.current.value = stock.date;
    currentStock.current.value = stock.quantity;
    selectedStock.current.value = stock.company;
    soldQuantity.current.value = currentStock.current.value - soldQty;
  };

  const getEditedStock = (id) => {
    if (document.getElementById("editingModalSuccess")) {
      document.getElementById("editingModalSuccess").classList.add("d-none");
    }
    const stockId = id;
    let stock = buyingList.find((list) => list.id === stockId);
    buyDateEdit.current.value = stock.date;
    buyPriceEdit.current.value = (+stock.price).toFixed(2);
    buyQuantityEdit.current.value = stock.quantity;
    editStockId.current.value = stock.id;
    document.querySelectorAll("#dropdownMenu")[0].value = stock.company;
  };

  const getAddedStock = (id) => {
    if (document.getElementById("addingModalSuccess")) {
      document.getElementById("addingModalSuccess").classList.add("d-none");
    }
    const stockId = id;
    let stock = buyingList.find((list) => list.id === stockId);
    // فيه مشكلة بعرض سعر السهم بعد الاضافة وفتح النافذة مرة اخرى لايمكن اضافة تو فيكس
    buyPriceAdd.current.value = (
      +stock.price +
      stock.totalFees / stock.quantity
    ).toFixed(2);
    buyNewTotal.current.value = 0;
    buyNewQntyPrice.current.value = 0;
    buyNewPrice.current.value = "";
    buyNewQnty.current.value = "";
    addStockId.current.value = stock.id;
    buyNewFinalTotal.current.value = stock.total.toFixed(2);
  };

  const calcNewAdd = () => {
    const stockId = addStockId.current.value;
    let stock = buyingList.find((list) => list.id === stockId);
    let newQnty = buyNewQnty.current.value;
    let newPrice = buyNewPrice.current.value;
    let newFee = fees / 100;
    let newVat = vat / 100;
    if (newQnty && newPrice) {
      buyNewTotal.current.value = (
        newQnty * newPrice +
        newQnty * newPrice * newFee +
        newQnty * newPrice * 0.00123 * newVat
      ).toFixed(2);
    } else {
      buyNewQntyPrice.current.value = 0;
      buyNewTotal.current.value = 0;
    }
    if (buyNewTotal.current.value > 0) {
      const totalStocks = +newQnty + +stock.quantity;
      buyNewQntyPrice.current.value = (
        (+buyNewTotal.current.value + stock.total) /
        totalStocks
      ).toFixed(2);
      buyNewFinalTotal.current.value = (
        +buyNewTotal.current.value + stock.total
      ).toFixed(2);
    }
  };

  const handleUpdatedQnty = (validation) => {
    if (!buyNewQnty.current.value || !buyNewPrice.current.value) {
      validation();
      return;
    }
    const stockId = addStockId.current.value;
    let stock = buyingList.find((list) => list.id === stockId);
    let newList = buyingList.filter((list) => list.id !== stockId);
    let newQnty = buyNewQnty.current.value;
    let newPrice = buyNewPrice.current.value;
    let newFee = fees / 100;
    let newVat = vat / 100;
    const total = stock.quantity * stock.price;
    const totalStocks = +newQnty + +stock.quantity;
    stock.price = (newQnty * newPrice + total) / totalStocks;
    stock.quantity = +newQnty + +stock.quantity;
    stock.totalFees =
      stock.totalFees +
      newQnty * newPrice * newFee +
      newQnty * newPrice * 0.00123 * newVat;
    stock.total =
      stock.total +
      newQnty * newPrice +
      newQnty * newPrice * newFee +
      newQnty * newPrice * 0.00123 * newVat;
    setBuyingLists([stock, ...newList]);
    getAddedStock(addStockId.current.value);
    if (document.getElementById("addingModalSuccess")) {
      document.getElementById("addingModalSuccess").classList.remove("d-none");
    }
  };

  const handleWallet = () => {
    let totalIncome = [];
    let totalLoses = [];
    let uncomletedStock = [];
    const profitArr = buyingList
      // .filter((list) => list.completed)
      .map((list) => list.sold);
    profitArr.forEach((element) => {
      element.forEach((element) => {
        if (element.profit >= 0) totalIncome.push(element.profit);
        if (element.profit < 0) totalLoses.push(element.profit);
      });
    });
    const uncomletedSoldStock = buyingList
      .filter((list) => !list.completed)
      .map((list) => list.sold);
    uncomletedSoldStock.forEach((element) => {
      element.forEach((element) => {
        uncomletedStock.push(element.totalCost);
      });
    });
    let sumTotalIncome = totalIncome.reduce((a, b) => a + b, 0);
    let sumTotalLoses = totalLoses.reduce((a, b) => a + b, 0);
    const currentStocks = buyingList
      .filter((list) => !list.completed)
      .map((list) => list.total)
      .reduce((a, b) => a + b, 0);
    const totalUncomletedSoldStock = uncomletedStock.reduce((a, b) => a + b, 0);
    const totalCurrentStocks = currentStocks - totalUncomletedSoldStock;
    setCurrentStocks(totalCurrentStocks);
    const balance = wallet - totalCurrentStocks;
    setBalance(balance);
    setProfit(sumTotalIncome);
    setLoses(sumTotalLoses);
    const total = +sumTotalIncome + +sumTotalLoses;
    setTotal(total);
  };
  //التحقق من خانات اضافة اسهم
  const formBuyingValidation = () => {
    if (document.getElementById("buyingModalSuccess")) {
      document.getElementById("buyingModalSuccess").classList.add("d-none");
    }
    if (buyDate.current.value === "") {
      document.getElementById("nodate").classList.remove("d-none");
      document
        .getElementById("nodateInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("nodate").classList.add("d-none");
      document
        .getElementById("nodateInput")
        .classList.remove("border", "border-danger");
    }
    if (buyNumber.current.value === "") {
      document.querySelectorAll("#nonumber")[1].classList.remove("d-none");
      document
        .querySelectorAll("#dropdownMenu")[1]
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.querySelectorAll("#nonumber")[1].classList.add("d-none");
      document
        .querySelectorAll("#dropdownMenu")[1]
        .classList.remove("border", "border-danger");
    }
    if (buyQuantity.current.value === "") {
      document.getElementById("noqnty").classList.remove("d-none");
      document
        .getElementById("buyQntyInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("noqnty").classList.add("d-none");
      document
        .getElementById("buyQntyInput")
        .classList.remove("border", "border-danger");
    }
    if (buyPrice.current.value === "") {
      document.getElementById("noprice").classList.remove("d-none");
      document
        .getElementById("buypriceInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("noprice").classList.add("d-none");
      document
        .getElementById("buypriceInput")
        .classList.remove("border", "border-danger");
    }
  };

  const removeValidation = () => {
    buyDate.current.value = "";
    buyNumber.current.value = "";
    buyQuantity.current.value = "";
    buyPrice.current.value = "";
    setSearchInput("");
    document.getElementById("nodate").classList.add("d-none");
    document
      .getElementById("nodateInput")
      .classList.remove("border", "border-danger");
    document.querySelectorAll("#nonumber")[0].classList.add("d-none");
    document
      .querySelectorAll("#dropdownMenu")[0]
      .classList.remove("border", "border-danger");
    document.querySelectorAll("#nonumber")[1].classList.add("d-none");
    document
      .querySelectorAll("#dropdownMenu")[1]
      .classList.remove("border", "border-danger");
    document.getElementById("noqnty").classList.add("d-none");
    document
      .getElementById("buyQntyInput")
      .classList.remove("border", "border-danger");
    document.getElementById("noprice").classList.add("d-none");
    document
      .getElementById("buypriceInput")
      .classList.remove("border", "border-danger");
    document.getElementById("buyingModalSuccess").classList.add("d-none");
  };

  //التحقق من خانات اضافة بيع اسهم
  const formSellingValidation = () => {
    if (document.getElementById("sellingModalSuccess")) {
      document.getElementById("sellingModalSuccess").classList.add("d-none");
    }
    const boughtDate = Date.parse(Bdate.current.value);
    const sellDate = Date.parse(soldDate.current.value);
    if (soldDate.current.value === "") {
      document.getElementById("noselldate").classList.remove("d-none");
      document
        .getElementById("selldateInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("noselldate").classList.add("d-none");
      document
        .getElementById("selldateInput")
        .classList.remove("border", "border-danger");
    }
    if (sellDate < boughtDate) {
      document.getElementById("nobdate").classList.remove("d-none");
      document
        .getElementById("selldateInput")
        .classList.add("border", "border-warning");
    } else {
      document.getElementById("nobdate").classList.add("d-none");
      document
        .getElementById("selldateInput")
        .classList.remove("border", "border-warning");
    }
    if (soldRemainQty.current.value === "") {
      document.getElementById("nosellqty").classList.remove("d-none");
      document
        .getElementById("sellqtyInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("nosellqty").classList.add("d-none");
      document
        .getElementById("sellqtyInput")
        .classList.remove("border", "border-danger");
    }
    if (+soldRemainQty.current.value > +soldQuantity.current.value) {
      document.getElementById("nosellqty1").classList.remove("d-none");
      document
        .getElementById("sellqtyInput")
        .classList.add("border", "border-warning");
    } else {
      document.getElementById("nosellqty1").classList.add("d-none");
      document
        .getElementById("sellqtyInput")
        .classList.remove("border", "border-warning");
    }
    if (soldPrice.current.value === "") {
      document.getElementById("nosellprice").classList.remove("d-none");
      document
        .getElementById("sellpriceInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("nosellprice").classList.add("d-none");
      document
        .getElementById("sellpriceInput")
        .classList.remove("border", "border-danger");
    }
  };

  const removeSoldValidation = () => {
    soldDate.current.value = "";
    soldRemainQty.current.value = "";
    soldPrice.current.value = "";
    document.getElementById("noselldate").classList.add("d-none");
    document
      .getElementById("selldateInput")
      .classList.remove("border", "border-danger");
    document.getElementById("nobdate").classList.add("d-none");
    document
      .getElementById("selldateInput")
      .classList.remove("border", "border-warning");
    document.getElementById("nosellqty1").classList.add("d-none");
    document.getElementById("nosellqty").classList.add("d-none");
    document
      .getElementById("sellqtyInput")
      .classList.remove("border", "border-danger");
    document
      .getElementById("sellqtyInput")
      .classList.remove("border", "border-warning");
    document.getElementById("nosellprice").classList.add("d-none");
    document
      .getElementById("sellpriceInput")
      .classList.remove("border", "border-danger");
    document.getElementById("sellingModalSuccess").classList.add("d-none");
  };

  return (
    <>
      <div className="main">
        <EditStock
          handleEditedStock={handleEditedStock}
          buyDateEdit={buyDateEdit}
          buyPriceEdit={buyPriceEdit}
          buyNumberEdit={buyNumberEdit}
          buyQuantityEdit={buyQuantityEdit}
          editStockId={editStockId}
          formBuyingValidation={formBuyingValidation}
          buyNumber={buyNumber}
          setSearchInput={setSearchInput}
          searchInput={searchInput}
        />
        <AddStock
          buyPriceAdd={buyPriceAdd}
          buyNumberAdd={buyNumberAdd}
          buyQuantityAdd={buyQuantityAdd}
          buyNewQnty={buyNewQnty}
          buyNewPrice={buyNewPrice}
          buyNewTotal={buyNewTotal}
          buyNewQntyPrice={buyNewQntyPrice}
          addStockId={addStockId}
          buyNewQntyPriceVat={buyNewQntyPriceVat}
          buyNewFinalTotal={buyNewFinalTotal}
          handleEditedStock={handleEditedStock}
          formBuyingValidation={formBuyingValidation}
          calcNewAdd={calcNewAdd}
          handleUpdatedQnty={handleUpdatedQnty}
        />
        <NavBar
          wallet={wallet}
          total={total}
          setWallet={setWallet}
          fees={fees}
          setFees={setFees}
          vat={vat}
          setVat={setVat}
          handleWallet={handleWallet}
          buyingList={buyingList}
          setBuyingLists={setBuyingLists}
        />
        <div className="mx-1 my-2">
          <Wallet
            buyingList={buyingList}
            currentStocks={currentStocks}
            balance={balance}
            total={total}
            profits={profits}
            loses={loses}
            wallet={wallet}
          />
        </div>
        <div
          className="modal fade"
          id="AdsModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-dark" id="exampleModalLabel">
                  حاسبة الأسهم
                </h5>
                <button
                  type="button"
                  className="close ml-0"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="ads">
                  <a
                    href="https://play.google.com/store/apps/details?id=stockCalc.stock&hl=ar&gl=US"
                    target="_blank"
                  >
                    <img src={Ads} alt="logo"></img>
                  </a>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=stockCalc.stock&hl=ar&gl=US",
                      "_blank"
                    );
                  }}
                  className="btn btn-primary"
                  data-dismiss="modal"
                >
                  تحميل التطبيق
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  اغلاق
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          class="alert alert-secondary mx-1 my-2"
          role="alert"
          id="updateAlert"
        >
          تم تحديث التطبيق للنسخة 1.0.2 وتعديل بعض الأخطاء البسيطة بناءًا على
          اقتراحاتكم. اذا ظهر لك في في خانة رصيد الصفقات الحالية أو الرصيد
          المتوفر NAN يرجى حذف عمليات البيع في الصفقات المفتوحة واضافتها من جديد
          وسيتم حل المشكلة
          <button
            type="button"
            className="close float-left "
            data-bs-dismiss="alert"
            aria-label="Close"
            onClick={() => {
              document.getElementById("updateAlert").classList.add("d-none");
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div> */}
        <div className="card text-light bg-primary m-1 mb-3">
          <div className="d-flex card-header pr-2">
            <h5 className="mb-0">الصفقات الحالية</h5>
            <button
              type="button"
              className="btn btn-light btn-sm mr-auto ml-2"
              data-toggle="modal"
              data-target="#buyingModal"
              onClick={removeValidation}
            >
              اضافة صفقة
            </button>
            <div
              className="modal fade"
              id="buyingModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5
                      className="modal-title text-dark"
                      id="exampleModalLabel"
                    >
                      اضافة
                    </h5>
                    <button
                      type="button"
                      className="close ml-0"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <Alert />
                  <div className="modal-body">
                    <form className="needs-validation">
                      <div className="form-row">
                        <div className="form-group col-md-12">
                          <label
                            htmlFor="validationCustom01"
                            className="text-dark"
                          >
                            تاريخ الشراء
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="nodateInput"
                            ref={buyDate}
                            onChange={formBuyingValidation}
                          ></input>
                          <small className="text-danger d-none" id="nodate">
                            يرجى اضافة التاريخ
                          </small>
                        </div>
                        <div className="form-group col-md-12">
                          <label htmlFor="inputPassword3" className="text-dark">
                            الشركة
                          </label>
                          <Search
                            setSearchInput={setSearchInput}
                            searchInput={searchInput}
                            buyNumber={buyNumber}
                            formBuyingValidation={formBuyingValidation}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="inputPassword3" className="text-dark">
                            عدد الاسهم
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="buyQntyInput"
                            ref={buyQuantity}
                            onChange={formBuyingValidation}
                          ></input>
                          <small id="noqnty" className="text-danger d-none">
                            يرجى اضافة عدد الاسهم
                          </small>
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="inputPassword3" className="text-dark">
                            سعر الشراء
                          </label>
                          <input
                            type="number"
                            step=".01"
                            className="form-control"
                            id="buypriceInput"
                            onChange={formBuyingValidation}
                            ref={buyPrice}
                          ></input>
                          <small id="noprice" className="text-danger d-none">
                            يرجى اضافة سعر الشراء
                          </small>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={handleAddStock}
                      className="btn btn-primary"
                      // data-dismiss="modal"
                    >
                      اضافة
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      اغلاق
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="sellingModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5
                      className="modal-title text-dark"
                      id="exampleModalLabel"
                    >
                      بيع اسهم
                    </h5>
                    <button
                      type="button"
                      className="close ml-0"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <AlertSold />
                  <div className="modal-body">
                    <form>
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label htmlFor="inputEmail3" className="text-dark ">
                            تاريخ البيع
                          </label>
                          <input
                            type="date"
                            id="selldateInput"
                            className="form-control"
                            onChange={formSellingValidation}
                            ref={soldDate}
                          ></input>
                          <input
                            type="hidden"
                            className="form-control"
                            ref={stockID}
                          ></input>
                          <input
                            type="hidden"
                            className="form-control"
                            ref={Bdate}
                          ></input>
                          <small id="noselldate" className="text-danger d-none">
                            يرجى اضافة تاريخ البيع
                          </small>
                          <small id="nobdate" className="text-warning d-none">
                            التاريخ المدخل قبل تاريخ الشراء
                          </small>
                        </div>
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="inputPassword3"
                            className="text-dark "
                          >
                            اسم الشركة
                          </label>
                          <input
                            ref={selectedStock}
                            type="text"
                            disabled
                            className="form-control"
                          ></input>
                        </div>
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="inputPassword3"
                            className="text-dark "
                          >
                            اجمالي عدد الاسهم
                          </label>
                          <input
                            ref={currentStock}
                            type="number"
                            disabled
                            className="form-control"
                          ></input>
                        </div>
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="inputPassword3"
                            className="text-dark "
                          >
                            الكمية المتبقيه
                          </label>
                          <input
                            ref={soldQuantity}
                            type="number"
                            disabled
                            className="form-control"
                          ></input>
                        </div>
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="inputPassword3"
                            className="text-dark "
                          >
                            الكميه
                          </label>
                          <input
                            type="number"
                            id="sellqtyInput"
                            ref={soldRemainQty}
                            onChange={formSellingValidation}
                            className="form-control"
                          ></input>
                          <small id="nosellqty" className="text-danger d-none">
                            يرجى اضافة عدد الاسهم
                          </small>
                          <small
                            id="nosellqty1"
                            className="text-warning d-none"
                          >
                            العدد المدخل اكبر من الكمية المتبقيه
                          </small>
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="inputPassword3" className="text-dark">
                            سعر البيع
                          </label>
                          <input
                            ref={soldPrice}
                            onChange={formSellingValidation}
                            type="number"
                            step=".01"
                            id="sellpriceInput"
                            className="form-control"
                          ></input>
                          <small
                            id="nosellprice"
                            className="text-danger d-none"
                          >
                            يرجى اضافة سعر البيع
                          </small>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={handleSoldStock}
                      className="btn btn-primary"
                      // data-dismiss="modal"
                    >
                      اضافة
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      اغلاق
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            href="#0"
            className="btn btn-link p-0 m-0 text-light position-absolute "
            id="main-collapse"
            data-toggle="collapse"
            data-target="#collapseExample"
            aria-expanded="true"
            aria-controls="collapseExample"
          >
            <i className="hany2">
              <BsChevronDoubleUp />
            </i>
            <i className="hany">
              <BsChevronDoubleDown />
            </i>
          </a>
          <div
            className="card-body bg-light text-dark p-0 collapse show"
            id="collapseExample"
          >
            <>
              {buyingList.some((list) => !list.completed) ? (
                <div className="table-responsive-xl">
                  <table className="table table-hover m-0">
                    <thead>
                      <tr className="text-center table-light text-dark">
                        <th scope="col">الشركة</th>
                        <th scope="col">تاريخ الشراء</th>
                        <th scope="col">الكمية</th>
                        <th scope="col">سعر الشراء</th>
                        <th scope="col">العمولات</th>
                        <th scope="col">تكلفة السهم</th>
                        <th scope="col">الاجمالي</th>
                        <th scope="col">التحكم</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      <>
                        {buyingList
                          .sort((a, b) => (b.date > a.date ? 1 : -1))
                          .map((list) => {
                            return (
                              <CurrentStocks
                                key={list.id}
                                list={list}
                                deleteStock={deleteStock}
                                deleteSoldStock={deleteSoldStock}
                                handleGetStock={handleGetStock}
                                getEditedStock={getEditedStock}
                                getAddedStock={getAddedStock}
                                removeSoldValidation={removeSoldValidation}
                                buyingList={buyingList}
                                buyNewQnty={buyNewQnty}
                                buyNewPrice={buyNewPrice}
                              />
                            );
                          })}
                      </>
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex flex-column justify-content-center align-items-center card-body bg-light text-dark">
                  <h5 className="mb-0">لا توجد صفقات حالية</h5>
                </div>
              )}
            </>
          </div>
        </div>
        <>
          <CompletedLists buyingList={buyingList} deleteStock={deleteStock} />
        </>
        <Footer />
      </div>
    </>
  );
}
